import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var tabletBreakPoint = "@media screen and (".concat(componentTheme.tabletBreakPoint, ")");
  var phoneBreakPoint = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    root: {
      padding: componentTheme.rootPadding
    },
    metricWrapper: {
      marginTop: componentTheme.wrapperMargin,
      paddingBottom: componentTheme.metricWrapperPadding
    },
    wrapper: {
      marginTop: componentTheme.wrapperMargin
    },
    metric: _defineProperty(_defineProperty({}, tabletBreakPoint, {
      flexBasis: '33.3%'
    }), phoneBreakPoint, {
      flexBasis: '50%'
    })
  };
};
export default generateStyle;